import isEmpty from 'lodash/isEmpty';

export const getItem = (id, items, { dataIsFlatten } = { dataIsFlatten: false }) => {
  if (dataIsFlatten) {
    return items.find((x) => String(x.id) === String(id));
  }

  let item = {};

  const find = (x) => {
    if (String(x.id) == String(id)) {
      item = x;

      return;
    }

    if (!isEmpty(x.children)) {
      x.children.forEach(find);
    }
  };

  items.forEach(find);

  return item;
};

export const isRootItem = (item, items) => {
  return items.some((x) => x.id == item.id);
};

export const itemHasChildren = (item) => {
  return (item.children || []).length;
};

export const isParentOfChild = (parent, child) => {
  const children =  (parent.children || []);

  return children.some((x) => x.id == child.id);
};

export const getRootItem = (id, items) => {
  const item = getItem(id, items);

  const getParent = (item) => {
    const foundItem = getItem(item.parentid, items);

    if (!isEmpty(foundItem)) {
      return getParent(foundItem);
    }

    return item;
  };

  return getParent(item);
};

export const getItemParents = (id, items) => {
  const item = getItem(id, items);

  const parents = [];

  const getParent = (item) => {
    const foundItem = getItem(item.parentid, items);

    if (!isEmpty(foundItem)) {
      parents.push(foundItem);
      return getParent(foundItem);
    }

    
  };
  
  getParent(item);

  return parents;
};

export const getAllChildren = (item) => {
  const children = [];

  item.children?.forEach((x) => {
    children.push(x);

    if (x.children?.length) {
      children.push(...getAllChildren(x));
    }
  });

  return children;
};

export const flattenTree = (data = []) => {
  const items = [];

  const pushItem = (item) => {
    items.push(item);

    item.children?.map((child) => {
      pushItem(child);
    });
  };

  data.forEach(pushItem);

  return items;
};